import { dateSchema } from '@optools/schemas/date';
import { BTCScheduleContextProvider } from '@optools/tools/btc-tools/context/btc-schedule-context';
import { PipelineControlsProvider } from '@optools/tools/btc-tools/context/pipeline-controls-context';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_auth/btc-tools/schedule')({
  component: RouteComponent,
  validateSearch: zodValidator(dateSchema),
});

export function RouteComponent() {
  return (
    <BTCScheduleContextProvider>
      <PipelineControlsProvider>
        <Outlet />
      </PipelineControlsProvider>
    </BTCScheduleContextProvider>
  );
}
